<template>
    <v-container fill-height fluid grid-list-xl class="terms-privacy">
        <v-layout justify-center wrap v-if="model">
            <v-flex xs12>
                <material-card>
                    <v-form>
                        <v-container fill-height fluid grid-list-xl>
                            <v-layout wrap style="background: #fff;" class="borderTop">

                                <v-flex md2 xs2 class="conTh py-2 borderBottom">게시일자</v-flex>
                                <v-flex md4 sx4 class="py-2 borderBottom  borderRight">{{model.created_at | time}}</v-flex>
                                <v-flex md2 xs2 class="conTh py-2 borderBottom">변경일시</v-flex>
                                <v-flex md4 sx4 class="py-2 borderBottom  borderRight">{{model.updated_at | time}}</v-flex>
                                <v-flex md2 xs2 class="conTh py-2 borderBottom">제목</v-flex>
                                <v-flex md10 sx10 class="py-2 borderBottom  borderRight">
                                    <v-text-field
                                            v-model="model.title"
                                            label="제목"
                                            flat
                                            solo
                                            hide-details
                                            :disabled="permission > 2?false:true"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex md2 xs2 class="conTh py-2 borderBottom">내용</v-flex>
                                <v-flex md10 xs10 class="pa-2  borderRight borderBottom">
                                    <div class="detailInfo ">
                                        <editor api-key='40gjhoe9qw4arr3ts44g2km7b2h1fli0elf1ymr6dh2k1mhb'
                                                cloud-channel='dev' :init="editorConfig"
                                                v-model="model.content"
                                                @change="change"
                                                :disabled="permission > 2?false:true"
                                        ></editor>
                                    </div>
                                </v-flex>

                                <v-flex xs12 text-xs-right>
                                    <v-btn class="mx-0 mr-1 font-weight-light" color="primary" outline @click="goList()">목록</v-btn>
                                    <v-btn class="mx-0 mr-1 font-weight-light" color="primary" outline @click="cancel()" v-if="permission > 2">취소</v-btn>
                                    <v-btn class="mx-0 mr-1 font-weight-light" color="primary" @click="save()" v-if="permission > 2">저장</v-btn>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-form>
                </material-card>
            </v-flex>

        </v-layout>
    </v-container>
</template>

<script>
    import MyMixinList from '../../mixins/MyMixinList'
    import MyMixinCommon from '../../mixins/MyMixinCommon';
    import { mapActions, mapGetters } from 'vuex'
    import { Terms } from '../../service/model/Terms'
    import Editor from '@tinymce/tinymce-vue';

    import * as termsApi from '../../service/api/terms-api'


    export default {
        mixins: [ MyMixinCommon, MyMixinList ],
        components: {
            'editor': Editor,
        },

        data: () => ({
            id: '2',
            model: new Terms(),
        }),
        created() {

        },
        computed: {
            pages() {
                if( this.pagination.rowsPerPage == null ||
                    this.pagination.totalItems == null
                ) return 0

                return Math.ceil( this.pagination.totalItems / this.pagination.rowsPerPage )
            }

        },
        methods: {
            ...mapGetters( 'user', [ 'getUserId','getLoginType' ] ),

            /////////////////////////////////////////////////// INIT /////////////////////////////////////////////////////////

            init() {
                // 개인정보 취급방침
                this.reqTerms()
            },

            change() {
                console.log(1)
            },

            /////////////////////////////////////////////////// FUNC /////////////////////////////////////////////////////////


            save() {
                if( ! this.model.title ) {
                    this.$dialog.alert( '제목을 입력해주세요.' )
                    return;
                }

                if( ! this.model.content ) {
                    this.$dialog.alert( '내용를 입력해주세요.' )
                    return;
                }

                let data = {
                    title: this.model.title,
                    content: this.model.content
                }

                this.$dialog.confirm( '저장 하시겠습니까?' )
                    .then( dialog => {
                        this.reqModifyTerms(data)
                    } )
                    .catch( function() {
                    } )


            },

            cancel() {
                this.$router.replace( { name: 'terms' } );
            },

            /////////////////////////////////////////////////// REQ /////////////////////////////////////////////////////////

            reqTerms() {

                return termsApi.findTerms( this.id ).then( res => {

                    // console.log( `Log ${this.$options.name} res = ${JSON.stringify( res.data, null, 2 )}` )

                    if( res.data ) {
                        this.model = res.data

                        this.permission = 4
                        // 자기가 쓴 글일 경우 퍼미션 변경
                        // if(res.data.user_id == this.getUserId())
                        // {
                        // 	this.permission = 4
                        // }
                    }
                } ).catch( e => {

                    if(e.code == '601'){
                        this.$dialog.alert( e.message ).then(dialog=>{
                            this.$router.replace( { name: 'terms' } );
                        })
                    }else{
                        this.$dialog.alert( e.message )
                    }
                } )
            },

            reqModifyTerms(data) {
                return termsApi.modifyTerms( data, this.model.id ).then( res => {
                    this.$router.replace( { name: 'terms' } );
                }).catch(e=>{
                    this.$dialog.alert(e.message)
                })
            },

            goList() {
                this.$router.replace( { name: 'terms' } );
            },
        },
    }

</script>

<style>
    .terms-privacy {
        padding: 0;
    }
</style>
